
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const RenewPredictionsPage = lazy(() => import('./RenewPredictionsPage'));
const path = 'reports/renew-predictions';
const RenewPredictionsRoute: FuseRouteItemType = {
	path: path,
	element: <RenewPredictionsPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Renew Predictions',
					helpName: 'Renew Predictions'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default RenewPredictionsRoute;
